import { render, staticRenderFns } from "./EtapaAgendamento.vue?vue&type=template&id=3d225245"
import script from "./EtapaAgendamento.vue?vue&type=script&lang=js"
export * from "./EtapaAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports